<rt-button
  #dropdownTrigger="rtOverlayOrigin"
  (mousedown)="placeholderSelectDropdownToggle($event)"
  [rtTooltip]="placeholderCategoryTranslationMap[category].desc"
  [rtTooltipMaxWidth]="300"
  [class.active]="placeholderSelectDropdown.open"
  variant="tertiary"
  size="small"
  rt-overlay-origin
>
  <span class="text">{{ placeholderCategoryTranslationMap[category].name }}</span>
  <rt-icon [name]="placeholderSelectDropdown.open ? 'arrow-drop-up' : 'arrow-drop-down'"></rt-icon>
</rt-button>

<ng-template
  #placeholderSelectDropdown="rtConnectedOverlay"
  [origin]="dropdownTrigger"
  [rtConnectedOverlayPosition]="['bottomleft']"
  (backdropClick)="placeholderSelectDropdown.open = false"
  rt-connected-overlay
  hasBackdrop
>
  <rt-placeholder-select-dropdown
    [placeholders]="placeholders"
    [activeTarget]="activeTarget"
    [category]="category"
    (select)="select.emit($event)"
  >
  </rt-placeholder-select-dropdown>
</ng-template>
